/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import LabelModel from '@/model/label/label.model';
import RemoteConnectionModel from '@/model/node/remoteConnection.model';

// This model is used to store basic info about the node inherited by NodeModel, used by AddEditNode
export default class NodeBasicInfoModel {
  /**
   * Creates an instance of NodeBasicInfoModel.
   * @param {Object} data - NodeBasicInfoModel
   * @class NodeBasicInfoModel
   * @property {string} name - Node name
   * @property {string} nodeId - Node id
   * @property {string} serialNumber - Node serialNumber
   * @property {string} hardwareName - Node hardwareName
   * @property {string} currentFWVersion - Node currentFWVersion
   * @property {string} labels - Node labels
   * @property {string} remoteConnections - Node remoteConnections
   * @property {string} timezone - Node timezone
   */
  constructor(data = {}) {
    this.id = this._id = data._id;
    this.name = data.name || '';
    this.nodeId = data._id || data.nodeId || '';
    this.serialNumber = data.serialNumber || '';
    this.hardwareName = data.hardwareName || '';
    this.currentFWVersion = data.currentFWVersion || '';
    this.labels = data.labels ? data.labels.map((l) => new LabelModel(l)) : [];
    this.remoteConnections = data.remoteConnections
      ? data.remoteConnections.map((rc) => new RemoteConnectionModel(rc))
      : [];
    this.timezone = data.timezone || {};
  }

  get transformedLabels() {
    return this.labels.reduce(
      (transformedString, l, index) =>
        `${transformedString} ${l.transformed}${index + 1 < this.labels.length ? ',' : ''}`,
      '',
    );
  }
}
